import * as WindowManagement from "@omni/services/windowManagement";
import { WindowKeys } from "@omni/services/windowManagement";
import { isDefined } from "@omni/utils/helper.utils";
import * as LocalStorage from "@omni/utils/localStorage.utils";

import { StorageKeys } from "@/utils/enums";

export default class SearchService {
    static setCutoff(cutoff: number): void {
        if (!isDefined(cutoff)) return;

        LocalStorage.setItem(
            StorageKeys.AlgoliaDynamicFacetNamesCutoff,
            cutoff.toString()
        );
    }

    static setAmount(amount: number): void {
        if (!amount) return;

        LocalStorage.setItem(
            StorageKeys.AlgoliaDynamicFacetNamesAmount,
            amount.toString()
        );
    }

    static resetParams() {
        LocalStorage.removeItem(StorageKeys.AlgoliaDynamicFacetNamesAmount);
        LocalStorage.removeItem(StorageKeys.AlgoliaDynamicFacetNamesCutoff);
    }
}

const init = () => {
    WindowManagement.saveObject(WindowKeys.SEARCH, SearchService);
};

export { init };
